import React, {useEffect, useRef} from 'react'
import {useFormContext} from 'react-hook-form'
import {capitalizeFirstLetter} from 'utils/capitalizeFirstLetter'
import {Label} from './Label'
import {twMerge} from 'tailwind-merge'
import APP_CONFIG from 'constants/clientConfigs'

export interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string
  name: string
  label?: string
  info?: string | React.ReactElement
  placeholder?: string
  icon?: React.ReactNode
  type?: string
  autoFocus?: boolean
  autocomplete?: string
  labelClassName?: string
}

export const Input = ({
  type = 'text',
  className,
  name,
  label,
  info = '',
  placeholder = ' ',
  icon,
  autoFocus,
  onKeyUp,
  onKeyDown,
  onKeyPress,
  onChange,
  autocomplete = 'on',
  disabled,
  labelClassName,
}: Props) => {
  const {outlineFocusColor} = APP_CONFIG[process.env.REACT_APP_CLIENT_ID]
  const {
    register,
    formState: {errors},
  } = useFormContext() || {}
  const error = errors[name] as any
  // const value = rest.value || watch(name) || undefined;
  const ref = useRef<any>(null)
  // const innerProps = { ref, ...inputProps };

  useEffect(() => {
    if (autoFocus && ref && ref.current) ref.current.focus()
  }, [autoFocus, ref])

  const iconClasses = !!icon && `pr-10`

  return (
    <React.Fragment>
      {label && (
        <Label
          className={twMerge('font-semibold', labelClassName)}
          htmlFor={name}
          label={label}
          info={info}
        />
      )}
      <div className="relative text-form-icon focus-within:text-focus-icon">
        <input
          type={type}
          placeholder={placeholder}
          className={`block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2  sm:text-sm/6
              ${className}
             ${iconClasses}
             ,
             ${outlineFocusColor}
            `}
          {...(onKeyDown ? {onKeyDown: onKeyDown} : {})}
          {...(onKeyUp ? {onKeyUp: onKeyUp} : {})}
          {...(onKeyPress ? {onKeyPress: onKeyPress} : {})}
          // {...(onChange ? {onChange: onChange} : {})}
          {...(name ? register(name) : {})}
          autoComplete={autocomplete}
          onChange={onChange}
          disabled={disabled}
          onWheelCapture={e => {
            if (type === 'number') {
              e.currentTarget?.blur()
            }
          }}
        />
        <div className="customIcon absolute inset-y-0 right-0 pr-3 flex items-center">
          {icon}
        </div>
      </div>
      {error && (
        <p className="text-alert pt-1.5 text-xs text-red-700">
          {capitalizeFirstLetter(error.message)}
        </p>
      )}
    </React.Fragment>
  )
}
